<template>
    <section class="singpause-mitglieder-contacts">
        <div class="contacts">
            <h4>Schulpersonal</h4>
            <Table
                bordered
                striped
                small
                showFilter
                :responsive="true"
                :fields="fields"
                :items="items"
                :isBusy="busy"
                :size="size"
                sortBy="from_date"
                emptyText="Es wurden bisher keine Zuweisungen von Klassen für diese Schule vorgenommen"
            >
                <template v-slot:thead-top="{ data }">
                    <b-tr>
                        <b-td :colspan="data.columns - 1"></b-td>
                        <b-td class="text-center">
                            <b-button
                                v-if="checkRight('write')"
                                :size="size"
                                @click="extendAll"
                                variant="link"
                                :disabled="busy || extending.busy"
                                class="mv-table-action-btn"
                                >Alle Übertragen</b-button
                            >
                        </b-td>
                    </b-tr>
                </template>
                <template v-slot:schule_name="{ row: row }">
                    <b-link
                        :to="{ path: '/mitglieder/' + row.item.schule_id }"
                        >{{ row.value }}</b-link
                    >
                </template>

                <template v-slot:funktion="{ row: row }">
                    <b-input
                        v-model="row.item.funktion"
                        :size="size"
                        :disabled="!checkRight('write')"
                    />
                    <template v-if="validation">
                        <template v-if="validation[row.item.id]">
                            <p
                                class="small text-danger m-0 p-0"
                                v-for="error in validation[row.item.id]
                                    .funktion"
                                :key="error"
                            >
                                {{ error }}
                            </p>
                        </template>
                    </template>
                </template>

                <template v-slot:actions="{ row: row }">
                    <b-button
                        v-if="checkRight('write')"
                        :size="size"
                        @click="extendItem(row.id)"
                        variant="link"
                        :disabled="busy || extending.busy"
                        class="mv-table-action-btn"
                        >Übertragen</b-button
                    >
                    <b-button
                        v-if="checkRight('delete')"
                        :size="size"
                        @click="removeItem(row.id)"
                        variant="link"
                        class="text-danger mv-table-action-btn"
                        >Löschen</b-button
                    >
                </template>

                <template v-slot:custom-foot>
                    <b-tr>
                        <b-td>Neuen Datensatz anlegen:</b-td>
                        <b-td>
                            <!--<b-select
                                :options="schools.data"
                                :disabled="schools.busy"
                                :size="size"
                                v-model="newItem.current.schule_id"
                            />-->
                            <FilteredSelect
                                :options="schools.data"
                                :size="size"
                                :disabled="schools.busy"
                                v-model="newItem.current.schule_id"
                            />
                            <template v-if="newItemValidation.errors.schule_id">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in newItemValidation.errors
                                        .schule_id"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td>
                            <b-input
                                v-model="newItem.current.funktion"
                                :size="size"
                                placeholder="Position eingeben..."
                            />
                            <template v-if="newItemValidation.errors.funktion">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in newItemValidation.errors
                                        .funktion"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td
                            ><b-button
                                variant="link"
                                :size="size"
                                :disabled="busy || newItemValidation.busy"
                                @click="addItem"
                                >Anlegen</b-button
                            ></b-td
                        >
                    </b-tr>
                </template>
            </Table>
        </div>
    </section>
</template>

<script>
import shortid from "shortid";
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import Currency from "@/mixins/Currency/Currency";
import SingPause from "@/mixins/SingPause/SingPause";
import { ApiFactory } from "@/api/ApiFactory.js";
import Table from "@/components/Table/Table";
import FilteredSelect from "@/components/FilteredSelect/FilteredSelect";
import SchoolYearDateInput from "@/components/SchoolYearDateInput/SchoolYearDateInput";

const SingPauseApi = ApiFactory.get("singpause");

export default {
    name: "SingPauseMitgliederContacts",
    mixins: [CommonView, Size, Currency, SingPause],
    props: ["id", "schools", "refresh", "validation"],
    components: {
        Table,
        FilteredSelect
        // SchoolYearDateInput
    },
    data() {
        return {
            api: SingPauseApi,
            fields: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true
                },
                {
                    key: "schule_name",
                    label: "Schule",
                    sortable: true
                },
                {
                    key: "funktion",
                    label: "Position",
                    class: "text-center"
                },
                {
                    key: "actions",
                    label: "Aktionen",
                    class: "text-center"
                }
            ],
            newItem: {
                default: {
                    id: null,
                    schule_id: null,
                    mitglied_id: null,
                    funktion: null
                },
                current: {
                    id: null,
                    schule_id: null,
                    mitglied_id: null,
                    funktion: null
                }
            },
            newItemValidation: {
                busy: false,
                errors: {}
            },
            extending: {
                busy: false
            }
        };
    },
    watch: {
        selectedSchoolYear: {
            handler() {
                this.fetch();
            }
        },
        items: {
            handler(val) {
                this.$emit("update", val);
            },
            deep: true,
            immediate: true
        },
        refresh: {
            handler() {
                this.fetch();
            }
        }
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await this.api.getContactsForSingleiter(
                this.id,
                this.selectedSchoolYear
            );
            if (response.ok && response.json.collection) {
                var items = response.json.collection;
                items = items.map(item => this.process(item));
                this.items = items;
                this.registerRights(response);
            } else {
                this.items = [];
                this.registerRights(response);
            }
            this.busy = false;
        },
        async addItem() {
            this.newItem.current["id"] = "new_" + shortid.generate();
            this.newItem.current.mitglied_id = this.id;
            const selectedSchool = this.schools.data.filter(
                item => item.value == this.newItem.current.schule_id
            );
            if (selectedSchool.length > 0) {
                this.newItem.current.schule_name = selectedSchool[0].text;
            }
            this.newItem.schule_name = this.newItemValidation.busy = true;
            const validate = await SingPauseApi.validateContacts(
                this.id,
                this.newItem.current
            );
            if (validate.ok) {
                this.items.push(this.newItem.current);
                this.newItem.current = { ...this.newItem.default };
                this.newItemValidation.errors = {};
            } else {
                console.error("Validaton error:", validate);
                this.newItemValidation.errors = validate.json.validation;
            }
            this.newItemValidation.busy = false;
        },
        removeItem(id) {
            this.items = this.items.filter(item => item.id !== id);
        },
        async extendItem(id) {
            this.extending.busy = true;
            const response = await SingPauseApi.extendContactEntry(this.id, id);
            if (response.ok) {
                this.makeToast(
                    "Übertragung erfolgreich",
                    `Der ausgewählte Datensatz ${id} wurde korrekt in das nächste Schuljahr übertragen`
                );
            } else {
                this.makeToast(
                    "Übertragung fehlerhaft",
                    `Der ausgewählte Datensatz ${id} wurde nicht übertragen!`,
                    "danger"
                );
            }
            this.extending.busy = false;
        },
        async extendAll() {
            this.extending.busy = true;
            const response = await SingPauseApi.extendMultipleContactEntries(
                this.id,
                this.selectedSchoolYear
            );
            if (response.ok) {
                this.makeToast(
                    "Übertragung erfolgreich",
                    `Der ausgewählten Datensätze wurden korrekt in das nächste Schuljahr übertragen`
                );
            } else {
                this.makeToast(
                    "Übertragung fehlerhaft",
                    `Der ausgewählten Datensätze wurde nicht übertragen!`,
                    "danger"
                );
            }
            this.extending.busy = false;
        }
    }
};
</script>
